import { render, staticRenderFns } from "./OpenedAtSeparator.vue?vue&type=template&id=2b21404e"
import script from "./OpenedAtSeparator.vue?vue&type=script&lang=js"
export * from "./OpenedAtSeparator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports